import React from "react";
import { Tooltip } from "@chakra-ui/react";
import useTouchOnly from "../hooks/useTouchOnly";

// 누르면 동작하는 컨트롤(이동·복사·토글·선택) 위의 툴팁 — 2026-09-27 말풍선 전수조사.
// Chakra Tooltip 은 터치 기기에서 hover 로는 안 열리고 탭 → focus 로 열린 뒤 다른 곳을 탭할 때까지 남는다.
// 실측: 상단바 등급 배지를 탭하면 /my-tier 로 옮겨간 뒤에도 말풍선이 새 화면 위에 떠 있었다(안드로이드).
// 마우스가 없는 기기에서는 툴팁을 끄고 aria-label 이 설명을 맡는다 — 이 컴포넌트를 쓰는 child 는 aria-label 을 가져야 한다.
// 설명만 보여주는 수동 요소(배지·숫자·심볼)는 InfoTooltip 을 쓴다 — 터치에서도 탭으로 열고 닫히며, 키보드로도 연다(src/components/InfoTooltip.jsx).
export default function ActionTooltip({ isDisabled, ...props }) {
  const touchOnly = useTouchOnly();
  return <Tooltip {...props} isDisabled={isDisabled || touchOnly} />;
}
